import { useMemo } from 'react';

import type { TPassportFormFields } from 'entities/creditForm';

import { AccordionHeaderParamsTexts } from './AccordionHeaderParams.texts';
import { getProtectedDescriptionWithUserData } from './getProtectedDescriptionWithUserData';
import { getProtectedTitleWithUserData } from './getProtectedTitleWithUserData';

type THeaderParams = {
  title: string;
  icon: string;
  description: string;
};

type DefaultParams = Partial<Pick<THeaderParams, 'title' | 'description'>>;

export const useAccordionHeaderParams = (
  data: Nullable<TPassportFormFields>,
  defaultData: DefaultParams,
  isOpen: boolean,
  isHideData?: boolean,
) => {
  const {
    title = defaultData.title || AccordionHeaderParamsTexts.HeaderDefaultTitle,
    description = defaultData.description || AccordionHeaderParamsTexts.HeaderDefaultDescription,
  } = useMemo((): Partial<THeaderParams> => {
    if (!data || isOpen) {
      return {};
    }

    return {
      title: getProtectedTitleWithUserData(data, isHideData) || AccordionHeaderParamsTexts.HeaderDefaultTitle,
      description:
        getProtectedDescriptionWithUserData(data, isHideData) || AccordionHeaderParamsTexts.HeaderDefaultDescription,
    };
  }, [data, isOpen, isHideData]);

  return [title, description] as const;
};
